import React, { useState } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';

import formatDateForAcquisitionDate from '../../../../../../../AcquisitionMetrics/helpers/formatDateForAcquisitionDate';
import { SURVEY_LANGUAGES } from '../../../../../../../../surveys/components/SurveyBuilderPage/SurveyBuilder/helpers/constants';
import SegmentedControl from '../../../../../../../../surveys/components/SurveyBuilderPage/Input/SegmentedControl/SegmentedControl';
import ImageUploadDropzone from './components/ImageUploadDropzone';

import styles from './BasicSettings.module.css';

export default ({
  internalPost,
  setInternalPost,
  datePickerPopupVisible,
  setDatePickerPopupVisible,
  containerTopScroll
}) => {
  const [activeLanguageTab, setActiveLanguageTab] = useState(
    SURVEY_LANGUAGES.DUTCH
  );

  const parseDate = dateString => {
    if (typeof dateString === 'string' && dateString.includes('/')) {
      const splitted = dateString.split('/');
      const day = parseInt(splitted[0], 10);
      const month = parseInt(splitted[1], 10);
      const year = parseInt(splitted[2], 10);
      const parsedDate = new Date(year, month - 1, day);
      if (parsedDate instanceof Date) {
        return parsedDate;
      }
    }
    return new Date();
  };

  const format = 'dd/MM/yyyy';

  const internalPostLanguageData =
    internalPost && internalPost.content && internalPost.content.length
      ? internalPost.content.find(c => c && c.language === activeLanguageTab)
      : null;

  const setInternalPostLanguageData = (property, value) => {
    const newInternalPostLanguageData = { ...internalPostLanguageData };

    let newInternalPostIndex =
      internalPost &&
      internalPost.content &&
      internalPost.content.findIndex(
        c => c && c.language === activeLanguageTab
      );

    const newContent = [...internalPost.content];

    if (newInternalPostIndex === -1) {
      newInternalPostLanguageData.language = activeLanguageTab;
      newInternalPostLanguageData.visible = true;
      newInternalPostLanguageData[property] = value;

      newInternalPostIndex =
        internalPost && internalPost.content ? internalPost.content.length : 0;
    } else if (newInternalPostIndex >= 0) {
      newInternalPostLanguageData[property] = value;
    }

    newContent[newInternalPostIndex] = newInternalPostLanguageData;

    // Make post content not visible that don't have all mandatory fields populated
    const requiredFields = ['title', 'description', 'image', 'postDate'];
    newContent.forEach(item => {
      const populatedFields = requiredFields.filter(
        field =>
          item[field] !== null &&
          item[field] !== undefined &&
          item[field] !== ''
      );

      if (item.visible && populatedFields.length !== requiredFields.length) {
        // eslint-disable-next-line no-param-reassign
        item.visible = false;
      }
    });

    setInternalPost({
      ...internalPost,
      content: newContent
    });
  };

  return (
    <div className={styles.content}>
      <SegmentedControl
        options={[
          { label: 'Dutch', value: SURVEY_LANGUAGES.DUTCH },
          { label: 'French', value: SURVEY_LANGUAGES.FRENCH }
        ]}
        value={activeLanguageTab}
        onClick={type => setActiveLanguageTab(type.value)}
        className={styles.surveyTypeSegmentedControlAdditionalstyle}
      />
      <div
        className={`${styles.additionalOptionCheck} ${styles.impact}`}
        style={{ marginTop: '25px' }}
      >
        <input
          type="checkbox"
          onChange={() => {
            if (internalPostLanguageData && internalPostLanguageData.visible) {
              setInternalPostLanguageData('visible', false);
            } else {
              setInternalPostLanguageData('visible', true);
            }
          }}
          checked={
            !!(internalPostLanguageData && internalPostLanguageData.visible)
          }
        />
        Visible
      </div>
      <>
        <div className={styles.subtitle}>
          Title
          <span className={styles.requiredAsterisk}>*</span>
        </div>
        <input
          className={styles.input}
          placeholder="Enter title"
          value={
            internalPostLanguageData && internalPostLanguageData.title
              ? internalPostLanguageData.title
              : ''
          }
          onChange={e => setInternalPostLanguageData('title', e.target.value)}
        />
      </>
      <>
        <div className={styles.subtitle}>
          Description
          <span className={styles.requiredAsterisk}>*</span>
        </div>
        <textarea
          placeholder="Type here"
          className={styles.textareaField}
          value={
            internalPostLanguageData && internalPostLanguageData.description
              ? internalPostLanguageData.description
              : ''
          }
          onChange={e =>
            setInternalPostLanguageData('description', e.target.value)
          }
        />
      </>
      <ImageUploadDropzone
        title="Image"
        internalPostLanguageData={internalPostLanguageData}
        setInternalPostLanguageData={setInternalPostLanguageData}
        activeLanguageTab={activeLanguageTab}
        propertyField="image"
        propertyFieldFullPath="imageFullPath"
      />
      <ImageUploadDropzone
        title="Social media card image"
        internalPostLanguageData={internalPostLanguageData}
        setInternalPostLanguageData={setInternalPostLanguageData}
        activeLanguageTab={activeLanguageTab}
        propertyField="socialMediaCardImage"
        propertyFieldFullPath="socialMediaCardImageFullPath"
      />
      <div className={styles.licenceDatesContainer}>
        <div className={styles.licenceSingleDateContainer}>
          <div
            className={
              datePickerPopupVisible
                ? styles.licenceSingleDateTitleStartDate
                : null
            }
          >
            Post date
            <span className={styles.requiredAsterisk}>*</span>
          </div>
          <div className={styles.licenceSingleDateInputContainer}>
            <div
              className={
                datePickerPopupVisible
                  ? styles.datePickerOuterContainer
                  : styles.datePickerNormalOuterContainer
              }
            >
              <div className={styles.datePickerOuterAbsoluteContainerStartDate}>
                <div
                  className={styles.datePickerOuterFixedContainer}
                  style={
                    datePickerPopupVisible
                      ? { marginTop: containerTopScroll }
                      : {}
                  }
                >
                  <DayPickerInput
                    key={
                      internalPostLanguageData &&
                      internalPostLanguageData.language
                    }
                    onDayChange={d => {
                      const proposedEndDate = new Date(d);
                      proposedEndDate.setFullYear(
                        proposedEndDate.getFullYear() + 1
                      );
                      setInternalPostLanguageData('postDate', d);
                    }}
                    value={
                      internalPostLanguageData &&
                      internalPostLanguageData.postDate
                        ? new Date(internalPostLanguageData.postDate)
                        : ''
                    }
                    dayPickerProps={{ canChangeMonth: true }}
                    placeholder="dd/mm/yyyy"
                    format={format}
                    formatDate={formatDateForAcquisitionDate}
                    parseDate={parseDate}
                    inputProps={{ readOnly: true }}
                    onDayPickerShow={() => {
                      setTimeout(() => {
                        setDatePickerPopupVisible(true);
                      }, 10);
                    }}
                    onDayPickerHide={() => setDatePickerPopupVisible(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <div className={styles.subtitle} style={{ marginTop: 15 }}>
          Click URL
        </div>
        <input
          className={styles.input}
          placeholder="Enter url"
          value={
            internalPostLanguageData && internalPostLanguageData.clickUrl
              ? internalPostLanguageData.clickUrl
              : ''
          }
          onChange={e =>
            setInternalPostLanguageData('clickUrl', e.target.value)
          }
        />
      </>
      <>
        <div className={styles.subtitle}>Click URL label</div>
        <input
          className={styles.input}
          placeholder="Enter click URL label"
          value={
            internalPostLanguageData && internalPostLanguageData.clickUrlLabel
              ? internalPostLanguageData.clickUrlLabel
              : ''
          }
          onChange={e =>
            setInternalPostLanguageData('clickUrlLabel', e.target.value)
          }
        />
      </>
      <div className={`${styles.additionalOptionCheck} ${styles.impact}`}>
        <input
          type="checkbox"
          onChange={() => {
            if (
              internalPostLanguageData &&
              internalPostLanguageData.likeEnabled
            ) {
              setInternalPostLanguageData('likeEnabled', false);
            } else {
              setInternalPostLanguageData('likeEnabled', true);
            }
          }}
          checked={
            !!(internalPostLanguageData && internalPostLanguageData.likeEnabled)
          }
        />
        Like enabled
      </div>
      <div className={`${styles.additionalOptionCheck} ${styles.impact}`}>
        <input
          type="checkbox"
          onChange={() => {
            if (
              internalPostLanguageData &&
              internalPostLanguageData.shareEnabled
            ) {
              setInternalPostLanguageData('shareEnabled', false);
            } else {
              setInternalPostLanguageData('shareEnabled', true);
            }
          }}
          checked={
            !!(
              internalPostLanguageData && internalPostLanguageData.shareEnabled
            )
          }
        />
        Share enabled
      </div>
    </div>
  );
};
